import { CONTACT } from "../lib/constants";
import { Phone, EnvelopeSimple, ArrowUpRight, WhatsappLogo, InstagramLogo, FacebookLogo } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      id="contact"
      data-testid="footer"
      className="relative bg-[#1A1A1A] text-[#F2F2EF] px-5 md:px-10 lg:px-16 pt-20 md:pt-28 pb-8 grain"
    >
      <div className="grid grid-cols-12 gap-6 md:gap-10 mb-12">
        <div className="col-span-12 md:col-span-7">
          <p className="eyebrow text-[#D85C3A]">09 — Let's talk</p>
          <h2 className="font-display text-[14vw] md:text-[10vw] lg:text-[9rem] uppercase leading-[0.85] tracking-tighter mt-2">
            Let's<br /><span className="text-[#D85C3A]">paint</span><br />something.
          </h2>
        </div>
        <div className="col-span-12 md:col-span-5 flex flex-col gap-5 md:pt-12">
          <a href={`tel:${CONTACT.phone}`} data-testid="footer-call" className="group flex items-start justify-between border-b-2 border-[#F2F2EF]/30 pb-4">
            <div>
              <div className="text-xs uppercase tracking-widest text-[#999]">Call us</div>
              <div className="font-display text-3xl md:text-4xl mt-1 group-hover:text-[#D85C3A] transition-colors">{CONTACT.phoneDisplay}</div>
            </div>
            <ArrowUpRight size={28} weight="bold" className="opacity-50 group-hover:opacity-100 group-hover:rotate-45 transition-all" />
          </a>
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="group flex items-start justify-between border-b-2 border-[#F2F2EF]/30 pb-4">
            <div>
              <div className="text-xs uppercase tracking-widest text-[#999]">Email</div>
              <div className="font-display text-xl md:text-2xl mt-1 break-all group-hover:text-[#D85C3A] transition-colors">{CONTACT.email}</div>
            </div>
            <ArrowUpRight size={28} weight="bold" className="opacity-50 group-hover:opacity-100 group-hover:rotate-45 transition-all" />
          </a>
          <a href={`https://wa.me/${CONTACT.whatsapp}?text=Hi%20Gurdeep%2C%20I%27d%20like%20a%20quote`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="group flex items-start justify-between border-b-2 border-[#F2F2EF]/30 pb-4">
            <div>
              <div className="text-xs uppercase tracking-widest text-[#999]">WhatsApp</div>
              <div className="font-display text-2xl mt-1 group-hover:text-[#D85C3A] transition-colors">Chat with Gurdeep</div>
            </div>
            <WhatsappLogo size={28} weight="duotone" className="opacity-70 group-hover:opacity-100" />
          </a>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6 border-t-2 border-[#F2F2EF]/30 pt-8">
        <div className="col-span-12 md:col-span-4">
          <div className="font-display text-xl">THE MELBOURNE PAINTERS</div>
          <p className="text-sm text-[#999] mt-2 max-w-xs">
            Premium residential & commercial painting across Melbourne metro. Owner-run since '08.
          </p>
        </div>
        <div className="col-span-6 md:col-span-2">
          <div className="text-xs uppercase tracking-widest text-[#999] mb-3">Site</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#work" className="hover:text-[#D85C3A]">Work</a></li>
            <li><a href="#services" className="hover:text-[#D85C3A]">Services</a></li>
            <li><a href="#estimator" className="hover:text-[#D85C3A]">AI Estimator</a></li>
            <li><a href="#book" className="hover:text-[#D85C3A]">Book</a></li>
          </ul>
        </div>
        <div className="col-span-6 md:col-span-3">
          <div className="text-xs uppercase tracking-widest text-[#999] mb-3">Areas</div>
          <ul className="space-y-2 text-sm">
            <li>Carlton · Fitzroy · Collingwood</li>
            <li>South Yarra · Toorak · Prahran</li>
            <li>St Kilda · Brighton · Brunswick</li>
            <li>+ all metro suburbs</li>
          </ul>
        </div>
        <div className="col-span-12 md:col-span-3">
          <div className="text-xs uppercase tracking-widest text-[#999] mb-3">Follow</div>
          <div className="flex gap-3">
            <a href="#" aria-label="instagram" className="border-2 border-[#F2F2EF] p-2 hover:bg-[#D85C3A] hover:border-[#D85C3A] transition-colors">
              <InstagramLogo size={20} weight="duotone" />
            </a>
            <a href="#" aria-label="facebook" className="border-2 border-[#F2F2EF] p-2 hover:bg-[#D85C3A] hover:border-[#D85C3A] transition-colors">
              <FacebookLogo size={20} weight="duotone" />
            </a>
          </div>
          <Link to="/admin" data-testid="footer-admin-link" className="inline-block mt-6 text-xs uppercase tracking-widest text-[#666] hover:text-[#D85C3A]">
            Admin →
          </Link>
        </div>
      </div>

      <div className="border-t-2 border-[#F2F2EF]/30 mt-8 pt-6 flex flex-col md:flex-row justify-between gap-3 text-xs text-[#666]">
        <div>© {new Date().getFullYear()} The Melbourne Painters. All rights reserved.</div>
        <div>Made in Melbourne · Rebuilt with care</div>
      </div>
    </footer>
  );
}
